<template>
  <el-sub-menu
    v-if="menu.children && menu.children.length && isSubMenu"
    :index="menu.urlPath"
  >
    <template #title>
      <app-icon :name="menu.attributes.resourceIcon || 'apps-line'" />
      <span :class="{ c_font16: menu.type === '5' }">{{ menu.text }}</span>
    </template>
    <template
      v-for="subMenu in menu.children"
      :key="subMenu.urlPath"
    >
      <drawer-nav-item
        v-if="subMenu.type === '1'"
        :menu="subMenu"
        :pre-path="convertPrePath(menu)"
        v-bind="$attrs"
      />
    </template>
  </el-sub-menu>
  <el-menu-item
    v-else
    :index="menu.urlPath"
    @click="handleClick"
  >
    <app-icon :name="menu.attributes.resourceIcon || 'apps-line'" />
    <template #title>
      <span>{{ menu.text }}</span>
    </template>
  </el-menu-item>
</template>

<script lang="ts" setup>
import { ref, computed, PropType, useAttrs } from 'vue'
import { useRouter } from 'vue-router'
import type { IFunction, ResourcesChildrenTree } from '@y/types'

const props = defineProps({
  menu: {
    type: Object as PropType<ResourcesChildrenTree>,
    required: true,
  },
  prePath: {
    type: String as PropType<string>,
    default: '',
  },
})

const attrs = useAttrs()
const router = useRouter()

const menu = ref(props.menu)

const isSubMenu = computed(() => props.menu.children && props.menu.children.some(child => child.type === '1'))

const convertPrePath = (menu: ResourcesChildrenTree) => {
  const { parentId } = menu
  if (!parentId || parentId === '0') {
    return `/app${menu.urlPath}`
  }
  const { prePath } = props
  return `${prePath}`
}

const handleClick = () => {
  const { prePath } = props
  const call = attrs.onCall as IFunction
  const path = `${prePath}${props.menu.urlPath}`
  router.push({
    path,
  })
  call()
}
</script>

<style lang="less" scoped>
i.Ionicons {
  margin-right: 12px;
}
</style>
